
import { SetupContext } from 'vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Button from '@/components/elements/Button.vue'
import { useRouter } from 'vue-router'

export default {
  name: 'VisitApplicationThanks',

  components: {
    GoalButtons,
    Button
  },

  props: {
    state: {
      type: Object,
      require: true
    }
  },

  setup(props: any, context: SetupContext) {
    const router = useRouter()

    // 入力ページ経由じゃない場合は弾く
    if (!props.state.isLandingInput) {
      router.replace('/500')
    }

    // 申し込みフローの更新
    context.emit('update-flow', 3)

    // 確認ページに戻れないように
    context.emit('update-landing-state', false)

    const from = document.cookie
      .split('; ')
      .find((row) => row.startsWith('visitApplicationFrom'))
    const prevPage = from ? from.split('=')[1] : ''
    if (from) {
      document.cookie = 'visitApplicationFrom=; max-age=0; path=/'
    }

    return {
      prevPage
    }
  }
}
